import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { EntityNavigationHost, INavigationEntityRequest } from "src/app/assets/shared/entity-navigation-host";

@Component({
  selector: 'eic-asset-related-projects',
  template: `
    <div *ngIf="assetRelatedProjects$ | async as relatedProjects">
      <ng-container *ngIf="relatedProjects.length>0" >
        <h3>Related Projects</h3>
        <table class="projectSectionTable">
          <tr>
            <th>Project Name</th>
            <th>Relationship</th>

          </tr>
          <tr *ngFor="let relatedProject of relatedProjects">
            <td>
              {{ relatedProject.projectName }}&nbsp;&nbsp;
              <button mat-button (click)="openPage(relatedProject.projectId, relatedProject.projectName)">
                <mat-icon style="font-size: 20px; height: 20px; width: 20px; color: var(--hyperlink);">open_in_new</mat-icon>
              </button>
            </td>
            <td>{{ relatedProject.relationship }}</td>

          </tr>
        </table>
      </ng-container>
    </div>
    `
})
export class AssetRelatedProjects implements OnInit {
  @Input() assetRelatedProjects$: Observable<any[]>;

  constructor(
    private host: EntityNavigationHost) {

  }


  // This opens the project on top of the asset details.
  // Need to 
  //   - animate a new slide out
  //   - keep track of the current state
  //   - Switch state to load the data
  //   - allow return to a previous state
  // This suggests the need for some kind of PubSub service to hold
  // a stack of routes. When a new route is popped on to the stack
  // an animation is fired and we navigate to the new state
  // when closing the window, we pop the last state stored off 
  // the stack and navigate to it. 
  // If the stack is empty, close the drawer
  openPage(projectId: number, projectName: string) {
    const request: INavigationEntityRequest = {
      entityType: 'project',
      id: projectId,
      name: projectName,
      caption: 'Project Details'
    };

    this.host.openEntity(request)
  }


  // Stack Navigation
  // ----------------
  // The topmost item on the stack is always the current stae
  // Navigate: Assuming we are looking at an asset, the current
  // location was pushed onto the stack when navigating to it
  // Push a record of the new state onto the stack using the
  // navigation service

  // NavigateBack:  will be added to a back button at the 
  // top of the drawer and will pop the topmost item off
  // the stack and activate the current top state on the stack

  // Action                                         Stack
  // ------                                         -----
  // Looking at the list                            (empty)
  // Click on a row - open the drawer               (empty)     
  //                  open an asset
  //                  store the state of the asset
  // click on a project - open a project            state of the asset
  // close the asset - pop and activate             (empty)
  //                   top stack item
  // close asset - close the drawer                 (empty)

  ngOnInit(): void {

  }

}
